/* eslint-disable react/no-did-mount-set-state */
import React, {Component} from 'react';
import {isMobile}         from 'react-device-detect';
import {
  Container,
  Divider,
  Header,
  Image,
} from 'semantic-ui-react';
import _ from 'lodash';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';

// Global
import getMessage from '../../global/getMessage';
// Controller
import globalController from '../../global/globalcontroller';
// Images
import review from '../../images/review.png';
// Style
import '../MainStyle/MainTwo.scss';
import './MainReview.scss';
// Controller
import MainReviewController from './MainReviewController';

const listReview = [
  (width) => `https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Felodie.bessiere.7%2Fposts%2F3001031083265813&width=${width}`,
  (width) => `https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fem.cappella%2Fposts%2F10157755202271785&width=${width}`,
  (width) => `https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpampluch%2Fposts%2F10158448608773054&width=${width}`,
  (width) => `https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fjake.gurle%2Fposts%2F2328804563929901&width=${width}`,
  (width) => `https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fdelphine.colomb.18%2Fposts%2F10220916766243881&width=${width}`,
  (width) => `https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fcarchambault%2Fposts%2F10158083300911894&width=${width}`,
  (width) => `https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Festelle.sohne%2Fposts%2F10220244209876535&width=${width}`,
  (width) => `https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fcharlotte.perrin.54%2Fposts%2F10157276689662025&width=${width}`,
  (width) => `https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fbruno.torres.311493%2Fposts%2F3228162600588715&width=${width}`,
  (width) => `https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fcessgior%2Fposts%2F10160513378195385%3A0&width=${width}`,
  (width) => `https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fmaud.daujean%2Fposts%2F10156165323424029%3A0&width=${width}`,
];

const propTypes = {
  content      : PropTypes.arrayOf(PropTypes.object),
  lang         : PropTypes.shape({menu: PropTypes.object}),
  getFBReviews : PropTypes.func.isRequired,
};
const defaultProps = {
  content : null,
  lang    : {},
};

class MainReview extends Component {

  state = {
    reviews : [],
    id      : null,
  };

  async componentDidMount() {
    const reviews = await this.props.getFBReviews();
    this.setState({
      reviews : reviews.ratings.data,
      id      : reviews.id,
    });
  }

  render() {
    const {lang} = this.props;
    const contentMsg = this.props.content || getMessage('section.review.content', lang);
    const content = [];

    _.forOwn(contentMsg, (value, key) => {
      content.push(
        <p key={key}>
          {value}
        </p>
      );
    });

    const widhtIframe = isMobile ? 320 : 600;
    console.log(widhtIframe, listReview);
    return (
      <Container className='sgr-mainHome-grid-two-sub'>

        <Divider hidden />

        <Header
          as='h2'
          color='grey'
          inverted
          textAlign='center'
        >
          <Header.Content>

            <Image
              avatar
              size='small'
              src={review}
            />
            {ReactHtmlParser(getMessage('menu.review', lang))}
          </Header.Content>
        </Header>

        {content}
        {/* {*/}
        {/* listReview.map((rev, index) => (*/}
        {/* <iframe*/}
        {/* allow='encrypted-media'*/}
        {/* allowTransparency*/}
        {/* frameBorder='0'*/}
        {/* height='370'*/}
        {/* key={index}*/}
        {/* scrolling='no'*/}
        {/* src={rev(widhtIframe)}*/}
        {/* style={{*/}
        {/* border      : 'none',*/}
        {/* overflow    : 'hidden',*/}
        {/* width       : `${widhtIframe}px`,*/}
        {/* marginLeft  : 'auto',*/}
        {/* marginRight : 'auto',*/}
        {/* display     : 'block',*/}
        {/* }}*/}
        {/* width={widhtIframe}*/}
        {/* />*/}
        {/* ))*/}
        {/* }*/}

        {
          this.state.reviews
            .map(({open_graph_story}) => {
              const rev = open_graph_story;
              console.log('rev', rev.id);

              return (
                <div
                  className='fb-post'
                  data-href={`https://www.facebook.com/${this.state.id}/posts/${rev.id}/`}
                  data-width='500'
                  key={rev.id}
                />
              );
            })
        }

      </Container>
    );
  }

}

MainReview.propTypes = propTypes;
MainReview.defaultProps = defaultProps;

export default globalController(MainReviewController(MainReview));



// WEBPACK FOOTER //
// ./src/organisms/MainReview/MainReview.js